import { FunctionComponent } from 'react';

import styles from './ProgressBar.module.scss';

export type ProgressBarProps = {
  percentComplete?: number;
};

type FC = FunctionComponent<ProgressBarProps>;

const ProgressBar: FC = ({ percentComplete = 50 }: ProgressBarProps) => (
  <div className={styles.container}>
    <div className={styles.highlight} style={{ width: `${percentComplete}%` }} />
  </div>
);

export default ProgressBar;
